import { render, staticRenderFns } from "./DiskInfo.vue?vue&type=template&id=82d1968e"
import script from "./DiskInfo.vue?vue&type=script&lang=js"
export * from "./DiskInfo.vue?vue&type=script&lang=js"
import style0 from "./DiskInfo.vue?vue&type=style&index=0&id=82d1968e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports